<template>
    <BaseButton :theme="theme" :size="size" :disabled="disabled" @click="openDialog"
        ><slot>{{ t("teamPerspective.leave.action") }}</slot></BaseButton
    >
    <ConfirmationDialog
        v-model:open="open"
        :title="t('teamPerspective.leave.title', { name: teamName })"
        :text="t('teamPerspective.leave.description')"
        :description="t('teamPerspective.leave.description')"
        :confirm-label="busy ? t('teamPerspective.leave.pending') : t('teamPerspective.leave.action')"
        :cancel-label="t('teamPerspective.cancel')"
        :confirm-disabled="busy"
        :cancel-disabled="busy"
        :close-on-confirm="false"
        dialog-content-class="fs-mask"
        @confirm="leave">
        <template #content>
            <BaseNotification v-if="error" theme="error" :text="error" hide-dismiss />
        </template>
    </ConfirmationDialog>
</template>

<script setup lang="ts">
import { useFetch } from "~vue/api";
import BaseButton, { type ButtonSize, type ButtonTheme } from "~vue/components/BaseButton.vue";
import BaseNotification from "~vue/components/BaseNotification.vue";
import ConfirmationDialog from "~vue/components/ConfirmationDialog.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const {
    teamName,
    leaveUrl,
    disabled = false,
    theme = "secondary",
    size = "sm",
} = defineProps<{ teamName: string; leaveUrl: string; disabled?: boolean; theme?: ButtonTheme; size?: ButtonSize }>();
const emit = defineEmits<{ left: [] }>();
const { t } = useI18n();
const open = ref(false);
const busy = ref(false);
const error = ref("");

function openDialog() {
    error.value = "";
    open.value = true;
}

async function leave() {
    if (busy.value) {
        return;
    }
    busy.value = true;
    error.value = "";
    try {
        const { error: requestError, statusCode } = await useFetch(leaveUrl).post();
        if (requestError.value) {
            error.value = statusCode.value === 409 ? t("teamPage.leadLeaveHelp") : t("teamPerspective.leave.error");
            return;
        }
        open.value = false;
        emit("left");
    } catch {
        error.value = t("teamPerspective.leave.error");
    } finally {
        busy.value = false;
    }
}
</script>
